import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@app/_core/services/app.service';
import { LoginService } from '@app/_core/services/login.service';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { UserService } from '@app/_core/services/user.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-duplicate-user',
  templateUrl: './duplicate-user.component.html',
  styleUrls: ['./duplicate-user.component.scss'],
})
export class DuplicateUserComponent implements OnDestroy {
  private timeoutId: any;
  constructor(
    @Inject(APP_BASE_HREF) public baseHref: string,
    private loginService: LoginService,
    public bsModalRef: BsModalRef,
    private router: Router,
    private userService: UserService,
    private tmQueueService: TmQueueService,
    private appService: AppService,
    private webStorageService: WebStorageService
  ) {
    this.timeoutId = setTimeout(() => {
      this.logout();
    }, 20000);
  }

  logout() {
    clearTimeout(this.timeoutId);
    this.userService.logout();
    this.bsModalRef.hide();
  }

  continue() {
    clearTimeout(this.timeoutId);
    this.loginService.handleSecondLogginIn();
    this.bsModalRef.hide();
  }

  ngOnDestroy() {
    this.timeoutId && clearTimeout(this.timeoutId);
  }

}
